<template>
  <div> 
    <div class="save-status-indicator d-flex align-items-center">
      <!-- Icono -->
      <div class="icon-wrapper">
        <b-spinner v-if="status === 'saving'" small></b-spinner>
        <b-icon-cloud-check v-if="status === 'saved'" variant="success"></b-icon-cloud-check>
        <b-icon-cloud v-if="status === 'unsaved'" variant="secondary"></b-icon-cloud>
        <b-icon-cloud-slash v-if="status === 'error'" variant="danger"></b-icon-cloud-slash>
      </div>
      <!-- Texto -->
      <!-- <span class="status-text ml-2">{{ statusText }}</span> -->
    </div>
  </div>
</template>

<script>
import { BSpinner, BIconCloudCheck, BIconCloud, BIconCloudSlash } from 'bootstrap-vue';
export default {
  name: 'SaveStatusIndicator',
  components: { BSpinner, BIconCloudCheck, BIconCloud, BIconCloudSlash },
  props: {
    status: {
      type: String,
      required: true,
      validator: value => ['saved', 'unsaved', 'saving', 'error'].includes(value),
    },
  },
  computed: {
    statusText() {
      const texts = {
        saved: 'Guardado',
        unsaved: 'Cambios sin guardar',
        saving: 'Guardando...',
        error: 'Error al guardar',
      };
      return texts[this.status] || '';
    },
  },
}
</script>

<style scoped>
.save-status-indicator {
  color: #6c757d;
  font-size: 0.9rem;
}
.icon-wrapper {
  width: 20px;
  text-align: center;
  display: flex;
  align-items: center;
}
.status-text {
  transition: opacity 0.3s ease;
}
.icon-wrapper .b-icon {
  font-size: 1.5rem;
  vertical-align: middle;
}
</style>